<template>
  <v-row class="choose-model mb-8" align="center" justify="center">
    <v-snackbar v-model="snackbar" class="" top :timeout=1000 color="primary">
      <span class="font-weight-bold">{{ language.model.alert }}</span>
    </v-snackbar>
    <v-col cols="12">
      <h2 class="mb-4 text-center text-md-center">
        {{ language.model.main_title }}
      </h2>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card class="d-inline-block ml-md-3 pointer" :class="selectedModel == 'horizontal' ? 'selected' : ''" outlined
        v-ripple="{ class: 'white-ripple' }" @click.native="changeModel('horizontal')">
        <v-icon v-if="selectedModel == 'horizontal'" class="selected" large>mdi-check</v-icon>
        <v-img class="white--text align-end mx-auto my-3" max-width="90%"
          src="../assets/img/orizontal_panou.png"></v-img>
        <v-card-title class="grey lighten-4 justify-center">{{ language.model.model1 }}</v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card class="d-inline-block ml-md-3 pointer" :class="selectedModel == 'vertical' ? 'selected' : ''" outlined
        v-ripple="{ class: 'white-ripple' }" @click.native="changeModel('vertical')">
        <v-icon v-if="selectedModel == 'vertical'" class="selected" large>mdi-check</v-icon>
        <v-img class="white--text align-end mx-auto my-3" max-width="90%"
          src="../assets/img/vertical_panou.png"></v-img>
        <v-card-title class="grey lighten-4 justify-center">{{ language.model.model2 }}</v-card-title>
      </v-card>
    </v-col>
    <div v-if="is_mobile_screen" class="mobile-space"></div>
  </v-row>
</template>

<script>
export default {
  name: "Model",
  data: function () {
    return {
      selectedModel: "horizontal",
      snackbar: false,
    };
  },
  props: ["language", "is_mobile_screen"],
  computed: {},
  methods: {
    changeModel(value) {
      this.selectedModel = value;
      this.$emit("changeModel", this.selectedModel);
    },
  },
};
</script>

<style lang="css"></style>
